/* eslint-disable no-console */
import axios from 'axios';
import { useEffect, useState } from 'react';
import { BASE_URL, STATIONS, ALERT } from '../../api/config';

const useFetchAlert = () => {
  const [alert, setAlert] = useState([]);

  useEffect(() => {
    async function getAlert() {
      axios({
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
          'Access-Control-Allow-Headers':
            'x-access-token, Origin, X-Requested-With, Content-Type, Accept',
        },

        url: `${BASE_URL}${STATIONS}${ALERT}`,
      })
        .then((response) => {
          setAlert(response.data);
        })
        .catch((e) => {
          console.error(e);
        });
    }
    getAlert();

    const getRefreshAlert = () => {
      const minutes = new Date().getMinutes();
      if (minutes === 0 || minutes === 20 || minutes === 40) {
        getAlert();
      }
    };

    setInterval(() => {
      getRefreshAlert();
    }, 1000 * 60);
  }, []);

  return { alert };
};

export default useFetchAlert;
